import _ from 'underscore';
import { isLocal } from '../configurations';

const validTenants = isLocal() ? ['cba', 'bbl', 'hic', 'sun', 'nab', 'fdm', 'cal', 'kyc', 'wbc', 'wdm', 'tyr'] : "cba,bbl,hic,suncorpbank,nab,fdm,cal,kyc,wbc,wdm,tyr".split(",");

class Tenant {
    isValid(tenantName) {
        return _.contains(_.map(validTenants, t => t.toLowerCase()), tenantName.toLowerCase());
    }

    getName() {
        const tenantName = document.location.host.split(".")[0];

        if (this.isValid(tenantName))
            return tenantName;
        else
            return 'invalid';
    }

    getTheme() {
        const tenantName = this.getName();

        if (tenantName !== 'invalid')
            return tenantName.concat('.theme.scss');
        else
            return 'default.theme.scss';
    }
}

export default new Tenant;



// WEBPACK FOOTER //
// ./app/util/tenant.js